<template>
	<div class="sys-version">
		<div>Version: v{{ latestNoteVersion }}</div>
		<div>© 2025 Blue Planet Training, Inc. DBA LifeHikes. All rights reserved.</div>
		<div class="lh-footer-links">
			<a href="https://lifehikes.com/privacy-policy/" target="_blank" rel="noopener" class="lh-footer-link">
				Privacy Policy
			</a>
			<span class="lh-footer-separator">|</span>
			<button type="button" @click="openCookieSettings" class="lh-footer-btn">
				Cookie Settings
			</button>
		</div>
	</div>
</template>

<script>
import releaseNote from "@/log/release-note";
import { cookieConsentManager } from '@/utils/CookieConsentManager';

export default {
	name: 'VersionInfo',
	computed: {
		latestNoteVersion() {
			return releaseNote[0].version + " (" + process.env.VUE_APP_ENV + ")";
		}
	},
	methods: {
		openCookieSettings() {
			cookieConsentManager.showPreferences();
		}
	}
}
</script>
<style lang="scss" scoped>


.sys-version{
    width: 100%;
	text-align: center;
    color: #60666C;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    margin-bottom: 40px;
     margin-top: 40px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    align-self: stretch;
    position: fixed;
    bottom: 0;
}

.lh-footer-links {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	flex-wrap: wrap;
	margin-top: 2px;
}

.lh-footer-link {
	color: #0056FF;
	font-weight: 600;
	text-decoration: none;
	background-color: transparent;
	&:hover {
		text-decoration: underline;
	}
}

.lh-footer-separator {
	color: #CED4D9;
}

.lh-footer-btn {
	color: #0056FF;
	font-weight: 600;
	text-decoration: none;
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	display: inline;
	font-size: 12px;
	font-family: inherit;
	&:hover {
		text-decoration: underline;
	}
	&:focus-visible {
		outline: 2px solid #0056FF;
		outline-offset: 2px;
	}
}

@media (max-height:667px) {
			 .sys-version{
                 position: unset ;
             }
		}
</style>